// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  margin-top: 36px;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: 0;
}
.container * {
  margin-left: auto;
  margin-right: auto;
}

.btn {
  margin: 20px;
  text-align: center;
  width: 50px;
  height: 50px;
  background-color: red;
}`, "",{"version":3,"sources":["webpack://./src/constructor.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;AACJ;AAAI;EACI,iBAAA;EACA,kBAAA;AAER;;AACA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAEJ","sourcesContent":[".container {\r\n    margin-top: 36px;\r\n    display: flex;\r\n    width: 100%;\r\n    flex-direction: row;\r\n    align-items: flex-end;\r\n    justify-content: center;\r\n    margin-bottom: 0;\r\n    * {\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n}\r\n.btn {\r\n    margin: 20px;\r\n    text-align: center;\r\n    width: 50px;\r\n    height: 50px;\r\n    background-color: red;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
